import gql from 'graphql-tag';

export const getAllEscalationRules = gql`
  query getAllEscalationRules($channelId: UUID!) {
    getAllEscalationRules(channelId: $channelId) {
      id
      entityType
      status
      timeToEscalate
      workflowId
      extRefId
      createdAt
      createdBy
      updatedAt
      updatedBy
      isArchived
    }
  }
`;
